import { Logo } from '@presentation/components';
import type { FC } from 'react';
import * as Styled from './styled';
import type { PartnerInfoBoxProps } from './types';

export * from './types';

export const PartnerInfoBox: FC<PartnerInfoBoxProps> = (props) => {
  const { title, content } = props;

  return (
    <Styled.PartnerContainer>
      <Styled.PartnerTitleContainer>
        <Styled.PartnerTitle>{title}</Styled.PartnerTitle>
        <Logo type="tipaw" color="yellow" />
      </Styled.PartnerTitleContainer>

      <div dangerouslySetInnerHTML={{ __html: content }} />
    </Styled.PartnerContainer>
  );
};
